import store from '@/store'

/**
 * For routes where the user has to be logged out.
 */
const isLoggedOutGuard = (to, from, next) => {
  const loggedIn = store.getters['auth/loggedIn']

  if (!loggedIn) next()
  else next({ name: 'dashboard' })
}

/**
 * For routes where the user has to be logged in.
 */
const isLoggedInGuard = (to, from, next) => {
  const loggedIn = store.getters['auth/loggedIn']

  if (loggedIn) next()
  else next({ name: 'login' })
}

/**
 * For routes where the user has to have permission
 * When using this guard, route.meta.permission must be defined
 */
const hasPermissionGuard = (to, from, next) => {
  const loggedIn = store.getters['auth/loggedIn']
  const user = store.getters['auth/authUser']
  const superAdmin = store.getters['auth/superAdmin']
  const requiredPermission = to.meta.permission

  if (superAdmin) next()
  else if (loggedIn && user.permissions.includes(requiredPermission)) next()
  else next({ name: 'login' })
}

export default {
  isLoggedOutGuard,
  isLoggedInGuard,
  hasPermissionGuard
}
